import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=0a6bbc82&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=ts"
export * from "./ImagePreview.vue?vue&type=script&lang=ts"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=0a6bbc82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6bbc82",
  null
  
)

export default component.exports